const gradientTracking = (): void => {
  const gradientTrackingSections = document.querySelectorAll<HTMLElement>(
    '[data-gradient-tracking="true"]'
  );
  gradientTrackingSections.forEach((section) => {
    section.addEventListener('mousemove', (e) => {
      const rect = section.getBoundingClientRect(),
        x = e.clientX - rect.left,
        y = e.clientY - rect.top;
      section.style.setProperty('--x', x + 'px');
      section.style.setProperty('--y', y + 'px');
    });
  });
};

export default gradientTracking;
